// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"49":"DevCreation","443":"about"}[chunkId] + "." + {"49":"a63d3e54","443":"5b28cd31"}[chunkId] + ".js";
};